const ASSET_DIRECTORY = 'apollo-assets';

export const mapAssetsBaseUrl = (bucketName: string): string =>
  `https://s3.amazonaws.com/${bucketName}/${ASSET_DIRECTORY}`;
